import defaultReducer from "./defaultReducer";

export default defaultReducer("ADD_COMMENTS_MODAL", {
  open: false,
  siteText: "",
  weekText: "",
  egmText: "",
  onSave: () => {},
});
